import React from 'react';
import SkeletonWrapper from '@shared/components/skeleton/SkeletonWrapper';

const LOADING_CARDS_COUNT = 2;

/**
 * @typedef {object} NotificationListProps
 * @property {Array<*>} [notifications]
 * @property {Map} notificationComponentMap
 * @property {boolean} [loading]
 */

/**
 * @param {NotificationListProps} props
 */
const NotificationList = props => {
  const { loading = false, notifications = [], notificationComponentMap } = props;

  if (loading) {
    return Array.from({ length: LOADING_CARDS_COUNT }, (_, index) => (
      <div key={index} data-testid={`notification-item-${index}`}>
        <hr />
        <SkeletonWrapper show={loading} inheritParentSize={true}>
          <div className='notification-card'></div>
        </SkeletonWrapper>
      </div>
    ));
  }

  return notifications.map((notification, index) => {
    const NotificationComponent = notificationComponentMap.get(notification.Type);

    return (
      <div key={index} data-testid={`notification-item-${index}`}>
        <hr />
        <NotificationComponent notification={notification} />
      </div>
    );
  });
};

export default NotificationList;
